import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaCreditCard, FaLayerGroup } from "react-icons/fa";
import SubscriptionPlanCard from "../components/SubscriptionPlanCard";
import { useTenant } from "../context/TenantContext";
import { useAppTheme } from "../context/AppThemeContext";
import { SUBSCRIPTION_PLANS } from "../data/subscriptionPlans";

const SubscriptionPlans = () => {
  const navigate = useNavigate();
  const { activeTenant } = useTenant();
  const { isDarkMode } = useAppTheme();
  const [selectedPlan, setSelectedPlan] = useState("");
  const selectedPlanDetails = SUBSCRIPTION_PLANS.find((plan) => plan.value === selectedPlan);

  const continueToPayment = () => {
    if (!selectedPlan) return;
    navigate(`/subscription-payment?plan=${encodeURIComponent(selectedPlan)}`);
  };

  const pageClass = isDarkMode
    ? "min-h-full bg-slate-950 py-8 text-slate-100"
    : "min-h-full bg-slate-50 py-8 text-slate-900";

  return (
    <div className={pageClass}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <section className="rounded-3xl bg-gradient-to-br from-blue-700 via-blue-600 to-teal-600 p-6 text-white shadow-2xl shadow-blue-900/20 sm:p-10">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-100">
            <FaLayerGroup aria-hidden="true" /> Upgrade your plan
          </p>
          <h1 className="mt-3 text-3xl font-black tracking-tight sm:text-4xl">Choose the plan that fits your school.</h1>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-blue-100">
            Select a billing duration for {activeTenant?.name || "your school"}. You can review the plan and final amount before opening secure checkout.
          </p>
        </section>

        <section className="mt-8">
          <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-4">
            {SUBSCRIPTION_PLANS.map((plan) => (
              <SubscriptionPlanCard
                key={plan.value}
                plan={plan}
                selected={selectedPlan === plan.value}
                onSelect={setSelectedPlan}
                isDarkMode={isDarkMode}
              />
            ))}
          </div>

          <div className={`mt-8 flex flex-col gap-4 border p-5 sm:flex-row sm:items-center sm:justify-between ${isDarkMode ? "border-slate-700 bg-slate-900" : "border-blue-200 bg-blue-50"}`}>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-600">Your selection</p>
              <p className={isDarkMode ? "mt-1 text-sm text-slate-300" : "mt-1 text-sm text-blue-800"}>
                {selectedPlanDetails
                  ? <><span className="font-bold">{selectedPlanDetails.name}</span> · {selectedPlanDetails.duration}</>
                  : "Select one of the plans above to continue."}
              </p>
            </div>
            <button
              type="button"
              onClick={continueToPayment}
              disabled={!selectedPlan}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-blue-700 to-teal-600 px-6 py-3 text-sm font-bold text-white shadow-lg shadow-blue-700/20 transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0"
            >
              <FaCreditCard aria-hidden="true" /> Continue to payment <FaArrowRight className="text-xs" />
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
